import { render } from "./ProductStorePopover.vue?vue&type=template&id=0fc7cae4&ts=true"
import script from "./ProductStorePopover.vue?vue&type=script&lang=ts"
export * from "./ProductStorePopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__